module.exports = __webpack_public_path__ + "images/jd-logo-green-md@1xfcc609ee2bf098ed02652faee3c4ef16fcc609ee2bf098ed02652faee3c4ef16.png";